var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('v-btn',{attrs:{"disabled":_vm.disableBookmarkButton,"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleBookmarkCurrentRoute.apply(null, arguments)}}},[_c('v-icon',{attrs:{"icon":""}},[_vm._v(" "+_vm._s(_vm.bookmarkIcon)+" ")])],1),(!_vm.disableBookmarkButton)?_c('bookmark-modals'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }